import React from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import BottomBox from "./BottomBox";
import Pop from "./Pop";
import { withRouter } from 'react-router-dom';
import './aero.css';


const Aero = (props) => {
    const { history } = props;
    return (
        <div className="aero-container">
            <Pop btcolor='black'/>
            
            <div className="aero-story">
            <div className="aero-sub-container">
                <div className="aero-sub-head">
                <h3>My team, some users and investors asked me</h3>
                <hr style={{border: 0,height: 0,borderTop: '1px solid rgba(0, 0, 0, 0.1)',borderBottom: '1px solid rgba(255, 255, 255, 0.3)',width:'70%',margin:'0% 70% 0% 0%'}}/>
                </div>
                <div className="blog__author" >
                    <img id='author-img' src="../images/shariq.jpg" alt="img" />
                    <p><b>Author</b>: Shariq Ahmed</p> 
                </div>
            </div>
            <div className="aero__content">
                <h1>Why is an aerospace startup working to build an autonomous sanitiser machine?</h1>
                <p>It was difficult to give a convincing answer ... so I just replied ... "We are making an emergency product in this pandemic" 
                but no one gets satisfied with this answer. We were in deep search for "why this product". Then later i found the reasons, 
                why are we working on an "autonomous sanitiser dispenser" machine, and those are here</p>
                <p>1.<b>Essential</b>: All of a sudden, people were just buying things that are essential and Soaron had only colorown, it's was a non-essential product in this pandemic.
                So things were so uncertain, we didn't even know when the pandemic will end. Then I did a survey, I got information from angel investors and mentors, they said "it will take at least 2-3 years for this pandemic to end". So with that,
                our team worked on something important and cost-effective and that was the project untouched.</p>
                <p>2.<b>Resources</b>: To build anything new, you must have the right team, so we had the right people who can execute things with passion
                and dedication. The other thing you should have a laboratory, to build and test and we had that too. And the third most important thing, 
                we had investors who already trusted us blindly and invested in colorown , it was a blessing for us.</p>
                <p>3.<b>Innovation</b>: Soaron is the place where we believe in solving society's problems and present them in the best way possible, 
                in simple words this is the actual Innovation. So we are the right organization to work on the "Autonomous Hand Sanitizer" 
                machine as this is solving society's problem in COVID time and we can present this solution in the best way to users.</p>
                <p>4.<b>Competitor</b>: Being a startup we always have a competitive advantage. As we added certain features to the product like a rechargeable battery, 
                app-based operation, and smart hanging where competitors didn't have these and it liked by our early customers who have pre-order our product.</p>
                <p>5.<b>Hardware Product</b>: Rarely you find hardware startups that work on innovative products why because they required the right vendors, 
                a talented team who execute things on time with quality and risk-take investors who can wait patiently for return at least 5 years, 
                while executing Colorown we got all these experiences.</p>
            </div>
            </div>
            {/* <div className="related-post"><span>Related Post</span></div>
            <Card sx={{ margin:'7% 0% 0% 10%',maxWidth: 345 }}>
            <CardMedia
                component="img"
                alt="img"
                height="140"
                image="/static/images/cards/contemplative-reptile.jpg"
            />
            <CardContent>
                <Typography sx={{'&:hover': { color: '#7D8B71'}}} onClick={()=> history.push('/blog/invest-project')} style={{fontSize:'1.1rem'}} gutterBottom variant="h5" component="div">
                    Why to Invest in Project Untouched?
                </Typography>
                <Typography style={{fontSize:'0.4rem',opacity:0.8}}>
                <p>BY UNTOUCHED | 17 FEB 2022</p>
                </Typography>
                <hr />
                <Typography style={{fontSize:'0.91rem'}}variant="h4" color="text.secondary">
                5 Reasons to invest in the project Generating wealth & employability Low Risk....
                </Typography>
            </CardContent>
            
            </Card> */}
            <BottomBox/>
        </div>
       
);
}
 
export default withRouter(Aero);